/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useTag } from '@api/hooks';
import { InfoItem } from '@molecules';

const Item = ({ module, previewImg, errors }) => {
  const { tag, error } = useTag(module.content.tagId);

  const description = module.content.tagId && (error ? 'Error loading tag' : tag.tag || 'loading tag...');

  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg} description={description}>
      Latest News Carousel
    </InfoItem.WithError>
  );
};

export default Item;
